/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_TopInputs */

const en_ocr_crop_top = /** @type {(inputs: Ocr_Crop_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top (%)`)
};

const fr_ocr_crop_top = /** @type {(inputs: Ocr_Crop_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haut (%)`)
};

const de_ocr_crop_top = /** @type {(inputs: Ocr_Crop_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spitze (%)`)
};

const it_ocr_crop_top = /** @type {(inputs: Ocr_Crop_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superiore (%)`)
};

const ru_ocr_crop_top = /** @type {(inputs: Ocr_Crop_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вершина (%)`)
};

const es_ocr_crop_top = /** @type {(inputs: Ocr_Crop_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arriba (%)`)
};

const zh_cn2_ocr_crop_top = /** @type {(inputs: Ocr_Crop_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顶部 （％）`)
};

const ja_ocr_crop_top = /** @type {(inputs: Ocr_Crop_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上位（％）`)
};

const hi_ocr_crop_top = /** @type {(inputs: Ocr_Crop_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्ष (%)`)
};

const pt_pt2_ocr_crop_top = /** @type {(inputs: Ocr_Crop_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principal (%)`)
};

/**
* | output |
* | --- |
* | "Top (%)" |
*
* @param {Ocr_Crop_TopInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_top = /** @type {((inputs?: Ocr_Crop_TopInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_TopInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_crop_top(inputs)
	if (locale === "de") return de_ocr_crop_top(inputs)
	if (locale === "it") return it_ocr_crop_top(inputs)
	if (locale === "ru") return ru_ocr_crop_top(inputs)
	if (locale === "es") return es_ocr_crop_top(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_crop_top(inputs)
	if (locale === "ja") return ja_ocr_crop_top(inputs)
	if (locale === "hi") return hi_ocr_crop_top(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_crop_top(inputs)
	return en_ocr_crop_top(inputs)
});